import React, { useState } from 'react'
import { IMAGE_URL } from '../Constants/constants';

export default function PhotosSections({ seller }) {
    const [open, setOpen] = useState(null);   // index of the enlarged photo
    const photos = [
        ...(seller.coverImage ? [seller.coverImage] : []),
        ...(seller.promoImage || []),
    ];

    if (photos.length === 0) {
        return (
            <div className="bp-panel bp-tab-empty">
                <span className="bp-empty-glyph" aria-hidden="true">🖼️</span>
                <h3>No photos yet</h3>
                <p className="bp-dim">This shop hasn't added any photos.</p>
            </div>
        );
    }

    return (
        <div className="bp-panel" style={{ padding: '26px' }}>
            <div className="bp-photo-grid">
                {photos.map((item, index) => (
                    <button className="bp-photo" key={index} onClick={() => setOpen(index)} aria-label="Enlarge photo">
                        <img alt="" src={IMAGE_URL + item} loading="lazy" />
                    </button>
                ))}
            </div>
            {open !== null && (
                <div className="bp-lightbox" onClick={() => setOpen(null)} role="dialog" aria-modal="true">
                    <img alt="" src={IMAGE_URL + photos[open]} />
                    <span className="bp-lightbox-close" aria-hidden="true">✕</span>
                </div>
            )}
        </div>
    )
}
